import { combineReducers } from 'redux';
import EntityPurchaseOrderReducer from './entity_purchase/reducer_entity_purchase_order';
import EntityPurchaseReceiptReducer from './entity_purchase/reducer_entity_purchase_receipt';
import EntityInventoryReturnReducer from './entity_purchase/reducer_entity_inventory_return';

export const entityPurchaseReducer = combineReducers( {
  'order'            : EntityPurchaseOrderReducer,
  'receipt'          : EntityPurchaseReceiptReducer,
  'inventory_return' : EntityInventoryReturnReducer 
} );